import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { MsalAuthenticationTemplate, MsalProvider } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';

import MainThemeProvider from 'themes/MainTheme';
import AuthenticationController from 'auth/AuthController';

import { InitializationLoadingPlaceholder } from 'components/shared/InitializationLoadingPlaceholder';
import config from 'config';
import { useRunOnceEffect } from 'hooks/useRunOnceEffect';

const App = ({ instance }) => {
  const [bootReady, setBootReady] = useState(false);

  useRunOnceEffect(() => {
    instance
      .handleRedirectPromise()
      .then(() => setBootReady(true))
      .catch((error) => {
        console.error('Error during MSAL redirect handling:', error);
        if (error.errorMessage.includes('AADB2C90118')) {
          window.location.href = config.forgotPasswordUrl;
        } else if (error.errorMessage.includes('AADB2C90091')) {
          const origin = window.location.origin;
          window.location.href = origin;
        } else {
          console.error('Unhandled MSAL error:', error);
        }
      });
  }, [instance]);

  if (!bootReady) {
    return <InitializationLoadingPlaceholder />;
  }

  return (
    <MsalProvider instance={instance}>
      <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
        <div className="app">
          <MainThemeProvider>
            <AuthenticationController />
          </MainThemeProvider>
        </div>
      </MsalAuthenticationTemplate>
    </MsalProvider>
  );
};

App.propTypes = {
  instance: PropTypes.object,
};

export default App;
